import { render } from "./Ingredients.vue?vue&type=template&id=46179ca0&scoped=true"
import script from "./Ingredients.vue?vue&type=script&lang=js"
export * from "./Ingredients.vue?vue&type=script&lang=js"

import "./Ingredients.vue?vue&type=style&index=0&id=46179ca0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46179ca0"]])

export default __exports__